import React from "react";
import FaqAndContactSection from "../components/Shared/FaqAndContactSection";

const sectionData = [
  {
    section: "Key Features",
    items: [
      {
        title: "Commission-Free Trading",
        description:
          "Enjoy direct transactions without intermediary fees, ensuring complete cost transparency.",
      },
      {
        title: "Verified Dealer Network",
        description:
          "Every dealer on WristLink is vetted, ensuring you connect only with trusted and legitimate businesses.",
      },
      {
        title: "Advanced Tools",
        description:
          "From pricing analytics and inventory management to secure direct messaging, WristLink offers tools to streamline every step of your business operations.",
      },
    ],
  },
  {
    section: "Who is it For?",
    items: [
      {
        title: "Smaller Dealers",
        description:
          "Build connections, expand your network, and access tools tailored for growth.",
      },
      {
        title: "Established Dealers",
        description:
          "Unlock enhanced network access and utilize advanced features to manage and scale your business efficiently.",
      },
      {
        title: "High-Volume Wholesalers",
        description:
          "Leverage WristLink’s platform to connect with global buyers and sellers and manage high-scale operations seamlessly.",
      },
    ],
  },
  {
    section: "Why WristLink?",
    items: [
      {
        title: "Transparency",
        description:
          "Trade with confidence, knowing there are no hidden fees or complex terms.",
      },
      {
        title: "Global Expansion",
        description:
          "Reach a broader audience of dealers across the globe, enabling you to expand your market and opportunities.",
      },
      {
        title: "Efficient Operations",
        description:
          "WristLink's user-friendly tools ensure you save time while maximizing business opportunities.",
      },
    ],
  },
  {
    section: "How to Get Started",
    items: [
      {
        title: "Sign Up",
        description: "Create your account by providing basic details.",
      },
      {
        title: "Verification",
        description:
          "Complete the verification process to ensure a secure network of trusted professionals.",
      },
      {
        title: "Start Connecting",
        description:
          "Use WristLink’s advanced tools to network, trade, and grow your business.",
      },
    ],
  },
];

const faqs = [
  {
    id: 1,
    question: "Is WristLink secure?",
    answer:
      "Yes, WristLink prioritizes security by verifying all dealers on the platform to ensure a trusted network.",
  },
  {
    id: 2,
    question: "How does commission-free trading work?",
    answer:
      "WristLink allows direct transactions between dealers without charging intermediary fees, enabling you to keep your profits.",
  },
  {
    id: 3,
    question: "What kind of tools does WristLink offer?",
    answer:
      "WristLink provides pricing analytics, inventory management systems, and secure direct messaging for seamless operations.",
  },
  {
    id: 4,
    question: "Can I trade internationally?",
    answer:
      "Absolutely! WristLink connects dealers globally, giving you access to a vast international network.",
  },
];

const LearnMorePage = () => {
  return (
    <section className=" py-20 z-10 container mx-auto max-w-[1200px]  lg:text-black md:text-black sm:text-black lg:px-4 md:px-4 sm:px-2">
      <h1 className="lg:text-2xl md:text-5xl font-bold mb-4  text-secondary">
        What is WristLink?
      </h1>

      <p className="text-xl">
        {/* <span className="bg-primary text-black px-1 "> */}
        WristLink is a secure and exclusive B2B marketplace for luxury watch
        dealers. Designed to connect professionals in the industry, it provides
        a seamless platform to trade, network, and grow on a global scale.
        {/* </span> */}
      </p>

      {/* Render sections */}

      <div className="mt-12">
        {sectionData?.map((sec, index) => (
          <div key={index} className="w-full mb-10">
            <h2 className="text-xl font-bold mb-4 text-secondary">
              {sec.section}
            </h2>
            <ul className="space-y-4">
              {sec.items.map((item, idx) => (
                <li key={idx} className="bg-gray-100 p-4 rounded-md shadow">
                  <h3 className="text-lg font-semibold">{item.title}</h3>
                  <p className="text-gray-700">{item.description}</p>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="w-full mt-[-40px]">
        <FaqAndContactSection faqs={faqs} />
      </div>
    </section>
  );
};

export default LearnMorePage;
